import React, {Component} from 'react';
import TextareaAutosize from 'react-autosize-textarea';

export default class TextEditor extends Component {

  state = {
    value: this.props.value || '',
  }

  onChange = (e) => {
    this.setState({value: e.target.value});
  }

  onBlur = (e) => {
    this.props.onBlur(this.state.value);
  }

  render() {
    const {formKey, placeholder} = this.props;
    return (
      <TextareaAutosize
        autoFocus={true}
        className="text-editor"
        name={formKey}
        onBlur={this.onBlur}
        onChange={this.onChange}
        onResize={(e) => {}}
        value={this.state.value}
        placeholder={placeholder}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/textField/TextEditor.jsx